<template>
  <div class="content no-flex active">
    <ed-section
      title=" "
      subtitle=" "
      class="no-flex active no-border"
      wide
      full-width
    >
      <ed-form
        :submit-visible='false'
      >
        <div class="col-md-5 col-md-offset-7 no-pad">
          <funding-address
            v-if="emailSettings.FundingAddress"
            :model="emailSettings.FundingAddress"
            :showEdit=true
            @changeAddress="(d) => $emit('changeAddress', d)"
          ></funding-address>

          <div class="form-group">
            <label>To</label>
            <br />
            <span class="small">
              {{ emailSettings.To }}
            </span>
          </div>

          <ed-input
            v-model="emailSettings.Cc"
            field-label="CC"
            :required="false"
            @input="emitChanges"
            name='apfile_cc'
          />

          <ed-input
            v-model="emailSettings.Bcc"
            field-label="BCC"
            :required="false"
            @input="emitChanges"
            name='apfile_bcc'
          />
          
          <div class="form-group">
            <label>Subject</label>
            <br />
            <div class="row">
              <span class="small col-md-10">
                {{ emailSettings.Subject }}
              </span>
            </div>
          </div>

          <replace-ap-file
            v-if="emailSettings.CanReplaceAuditFile"
            :apFile="getReplaceAuditFileModel()"
            :token="token"
          />

          <div class="well small clear email-body" v-html="emailSettings.EmailBody"></div>

          <ed-textarea
            v-model="emailSettings.Message"
            field-label="Add a custom message"
            :required="false"
            @input="emitChanges"
            name='apfile_message'
          />

          <div v-for="warning in emailSettings.Warnings" v-bind:key="warning">
            <p>{{warning}}</p>
          </div>

          <ed-upload
            :class='{loading: !uploadFinished}'
            field-label='Additional Documentation'
            button-label='Upload File'
            readonly
            :multiple='true'
            :postAction='api.env + api.$.upload.uploadFile'
            :uploadAuto='true'
            :data='uploadData'
            :required='false'
            @input='createAttachments'
            :showHelptipIcon='false'
            helptipHeader=''
            name='apfile_additional_files'
          ></ed-upload>
        </div>

      </ed-form>
    </ed-section>
  </div>
</template>


<script>

import { Eved } from '@/event-bus'

import ReplaceApFile from './components/ReplaceApFile.vue'
import FundingAddress from './components/FundingAddress.vue'

export default {
  name: 'SendApFile',

  components: {
    ReplaceApFile,
    FundingAddress
  },

  props: {
    emailSettings: Object,
    token: String
  },

  activated() {
    this.uploadFinished = true
  },

  data () {
    return {
      attachments: [],
      uploadFinished: true,
      attachmentsMissing: false,
      uploadData: {
        folder: 'Temp/',
        token: this.token
      }
    }
  },

  methods: {
    createAttachments(e) {
      let completedFiles = e.filter(
        item => item.success || // files uploaded with success
        (!item.success && item.response && typeof item.response === 'string' && !utils.json.valid(item.response)) // files where requested failed
      )

      if (completedFiles.length >= 1) {
        this.attachmentsMissing = false
      }

      if (completedFiles.length === e.length) {
        this.uploadFinished = true

        let uploadedfiles = e.map(item => {
          let uploadError = ''
          let itemResponse = null

          if (item.success && item.response) {
            itemResponse = JSON.parse(item.response)
            uploadError = (itemResponse && itemResponse.uploadError) ? itemResponse.uploadError : ''
          }
          if (!item.success) {
            uploadError = 'Upload request failed'
          }

          if (!uploadError) {
            return {
              AttachmentName: item.name,
              AttachmentSize: item.size,
              AttachmentFile: itemResponse ? itemResponse.file : (item.file || ''),
              AttachmentId: item.id || 0,
              AttachmentPath: itemResponse ? itemResponse.path : ''
            }
          }
        })

        this.attachments = uploadedfiles.map(item => {
          if (isNaN(item.AttachmentId)) {
            item.AttachmentId = 0
          }
          return item
        })
      } else {
        this.uploadFinished = false
      }

      this.emitChanges()
    },

    emitChanges() {
      let data = {
        divisionName: this.emailSettings.DivisionName,
        cc: this.emailSettings.Cc,
        bcc: this.emailSettings.Bcc,
        message: this.emailSettings.Message,
        attachments: this.attachments
      }

      this.$emit(Eved.PAYMENT.APFILE_FIELDS_CHANGES, data)
    },

    getReplaceAuditFileModel() {
      return {
        ApFileId: this.emailSettings.ApFileId,
        AuditFileNumber: this.emailSettings.AuditFileNumber
      }
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.email-body {
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/SendApFile.vue